import { render, staticRenderFns } from "./Novedades.vue?vue&type=template&id=8da0d306"
import script from "./Novedades.vue?vue&type=script&lang=js"
export * from "./Novedades.vue?vue&type=script&lang=js"
import style0 from "./Novedades.vue?vue&type=style&index=0&id=8da0d306&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports